import Title from "./Title";
import Menu from "./Menu";
import Illustration from "./Illustration";

const Hero = () => {
    return (
        <div className="hero-section">
            <header className="header">
                <p className="header-text">LAUREN ABRAMSKY</p>
                <Menu />
            </header>

            <main className="hero-content" role="main">
                <Title size="XL">
                    <span><i>Creative</i></span>
                    <span>Software</span>
                    <span>Developer</span>
                </Title>
                <Illustration className="hero-illustration" />
            </main>
        </div>
    );
};

export default Hero;